import {useMemo} from 'react';
import {SwapMatch} from '@/types/swapMatch';
import swapMatchFetchers from '@/api/fetchers/swapMatch';
import useDataQuery from '@/hooks/use-data-query';

interface UseSwapMatchesQueryParams {
  brandId?: string;
  profileId?: string;
  network?: string;
  enabled?: boolean;
}

function useSwapMatchesQuery({
  brandId,
  profileId,
  network,
  enabled = true,
}: UseSwapMatchesQueryParams) {
  const response = useDataQuery<SwapMatch[]>({
    queryKey: ['swapMatches', brandId, profileId, network],
    queryFn: swapMatchFetchers.getSwapMatchesByProfileId,
    enabled: enabled && !!brandId && !!profileId,
    meta: {brandId, profileId, network},
  });

  const swapMatches = useMemo(() => {
    if (!response.data) {
      return [];
    }
    return response.data;
  }, [response.data]);

  return {...response, data: swapMatches};
}

export default useSwapMatchesQuery;
